import { startApp } from "./mainControls";

import "tippy.js/dist/tippy.css";
import "mdb-ui-kit/css/mdb.min.css";
import "./eiraStyle.sass";

startApp();
